/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";
import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";
import {withCookies, useCookies, Cookies } from 'react-cookie';

const cookie = new Cookies();

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  const [cookies, setCookie, removeCookie] = useCookies();
  const [openGroups, setOpenGroups] = React.useState({});

  function toggleGroup(name) {
    setOpenGroups(function (prev) {
      var next = Object.assign({}, prev);
      next[name] = !prev[name];
      return next;
    });
  }

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    var href = window.location.href;
    var idx = href.indexOf(routeName);
    if (idx === -1) return false;
    var nextChar = href[idx + routeName.length];
    return !nextChar || nextChar === '/' || nextChar === '?' || nextChar === '#';
  }

  function isGroupActive(children) {
    for (var i = 0; i < children.length; i++) {
      if (children[i].buttonPath && activeRoute("/admin" + children[i].buttonPath)) {
        return true;
      }
    }
    return false;
  }

  function canSee(profiles) {
    return cookie.get('profile') == 'admin' || (profiles != null && profiles.includes(cookie.get('profile')));
  }

  function renderLink(prop, key, onNavigate) {
    if (prop.subRoute) return null;
    if (!canSee(prop.profiles)) return null;

    var fullPath = (prop.layout || "") + prop.buttonPath;
    var listItemClasses = classNames({
      [" " + classes[color]]: activeRoute(fullPath)
    });
    var whiteFontClasses = classNames({
      [" " + classes.whiteFont]: activeRoute(fullPath)
    });

    var inner = React.createElement(
      ListItem,
      { button: true, className: classes.itemLink + listItemClasses },
      React.createElement(Icon, { className: classes.itemIcon }, typeof prop.icon === "string" ? prop.icon : null),
      React.createElement(ListItemText, {
        primary: prop.name,
        className: classNames(classes.itemText, whiteFontClasses),
        disableTypography: true
      })
    );

    if (prop.openInNewTab) {
      return React.createElement(
        "a",
        {
          href: "#" + fullPath,
          target: "_blank",
          rel: "noopener noreferrer",
          className: classes.item,
          key: key,
          style: { textDecoration: "none" }
        },
        inner
      );
    }

    return React.createElement(
      NavLink,
      {
        to: fullPath,
        className: classes.item,
        activeClassName: "active",
        key: key,
        onClick: onNavigate || undefined
      },
      inner
    );
  }

  function renderNestedLink(prop, key, onNavigate) {
    if (prop.subRoute) return null;
    if (!canSee(prop.profiles)) return null;

    var listItemClasses = classNames({
      [" " + classes[color]]: activeRoute(prop.layout + prop.buttonPath)
    });
    var whiteFontClasses = classNames({
      [" " + classes.whiteFont]: activeRoute(prop.layout + prop.buttonPath)
    });

    return React.createElement(
      NavLink,
      {
        to: prop.layout + prop.buttonPath,
        className: classes.item,
        activeClassName: "active",
        key: key,
        onClick: onNavigate || undefined
      },
      React.createElement(
        ListItem,
        { button: true, className: classes.itemLink + listItemClasses, style: { paddingLeft: 30 } },
        React.createElement(Icon, { className: classes.itemIcon, style: { fontSize: 18 } }, typeof prop.icon === "string" ? prop.icon : null),
        React.createElement(ListItemText, {
          primary: prop.name,
          className: classNames(classes.itemText, whiteFontClasses),
          style: { fontSize: 13 },
          disableTypography: true
        })
      )
    );
  }

  function renderGroup(groupItem, key, onNavigate) {
    if (!canSee(groupItem.profiles)) return null;
    var isOpen = openGroups[groupItem.name] || isGroupActive(groupItem.children);

    var groupHeader = React.createElement(
      ListItem,
      {
        button: true,
        className: classes.itemLink,
        key: "group-" + key,
        onClick: function () { toggleGroup(groupItem.name); },
        style: { cursor: "pointer", display: "flex", alignItems: "center" }
      },
      React.createElement(Icon, { className: classes.itemIcon }, groupItem.icon),
      React.createElement(ListItemText, {
        primary: groupItem.name,
        className: classes.itemText,
        disableTypography: true,
        style: { flex: 1 }
      }),
      isOpen
        ? React.createElement(ExpandLess, { style: { color: "rgba(255,255,255,0.8)", marginLeft: "auto" } })
        : React.createElement(ExpandMore, { style: { color: "rgba(255,255,255,0.8)", marginLeft: "auto" } })
    );

    var childLinks = groupItem.children.map(function (child, idx) {
      return renderNestedLink(child, key + "-" + idx, onNavigate);
    }).filter(Boolean);

    var collapseBlock = React.createElement(
      Collapse,
      { in: isOpen, timeout: "auto", unmountOnExit: true },
      React.createElement(List, { component: "div", disablePadding: true }, childLinks)
    );

    return React.createElement("div", { key: key }, groupHeader, collapseBlock);
  }

  const { color, logo, image, logoText, routes } = props;

  function buildLinks(onNavigate) {
    var signOutItem = React.createElement(
      ListItem,
      {
        button: true,
        className: classes.itemLink,
        key: "sign-out",
        onClick: function () {
          ['api', 'course_list', 'students_list', 'mail_list'].forEach(function (v) {
            removeCookie(v, { path: '/' });
          });
          if (onNavigate) onNavigate();
        },
        style: { cursor: "pointer", marginTop: 20, borderTop: "1px solid rgba(255,255,255,0.15)", paddingTop: 15 }
      },
      React.createElement(Icon, { className: classes.itemIcon }, "exit_to_app"),
      React.createElement(ListItemText, {
        primary: "Cerrar Sesión",
        className: classes.itemText,
        disableTypography: true
      })
    );

    return React.createElement(
      List,
      { className: classes.list },
      routes.map(function (prop, key) {
        if (prop.group) {
          return renderGroup(prop, key, onNavigate);
        }
        return renderLink(prop, key, onNavigate);
      }).filter(Boolean).concat([signOutItem])
    );
  }

  var brand = (
    <div className={classes.logo}>
        <div className={classes.logoImage}>
          <img src={logo} alt="logo" className={classes.img} />
        </div>
        {logoText}
    </div>
  );
  return (
    <div>
      
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor="left"
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {buildLinks(props.handleDrawerToggle)}
          </div>
          <div className={classes.background} />
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{buildLinks(null)}</div>
          <div
              className={classes.background}
            />
          
        </Drawer>
      </Hidden>
      
      
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
